import { render, staticRenderFns } from "./NotificationsComponent.vue?vue&type=template&id=73295684&"
import script from "./NotificationsComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports